import { randSinger } from '@ngneat/falso';

import {
  VenueDate,
  VenueDateBasic,
} from '@/domain/project-venue-dates/entities/project-venue-dates.entity';
import { ProjectVenueDatesGateway } from '@/domain/project-venue-dates/gateways/project-venue-dates.gateway';

import { FAKE_PRESETS } from './api-project-venue-presets-fake.gateway';

export class ApiProjectVenueDatesFakeGateway implements ProjectVenueDatesGateway {
  venueDates = FAKE_VENUE_DATES;

  async getAll() {
    return this.venueDates;
  }

  async add(
    organisationId: number,
    projectId: number,
    date: string,
    name: string,
  ): Promise<void> {
    const venueDate: VenueDate = {
      id: this.venueDates.length,
      date: date,
      name: name,
      models: { env: '', ess: '' },
    };
    this.venueDates = [...this.venueDates, venueDate];
  }

  async delete(dateId: number) {
    this.venueDates = this.venueDates.filter((x) => x.id !== dateId);
  }
  async edit(venueDate: VenueDate) {
    return venueDate;
  }

  async bulkAdd(body: {
    dates: { date: string; name: string }[];
    projectId: number;
    organisationId: number;
  }): Promise<{ success: boolean }> {
    const newDates: VenueDate[] = body.dates.map((date) => {
      const dateObj = new Date(date.date);
      dateObj.setHours(16, 0, 0, 0);
      return {
        id: this.venueDates.length,
        date: dateObj.toISOString(),
        name: date.name,
        models: { env: '', ess: '' },
      };
    });
    this.venueDates = [...this.venueDates, ...newDates];
    return { success: true };
  }

  async importDatesFromHeeds(): Promise<VenueDateBasic[]> {
    await new Promise((r) => setTimeout(r, 2000));
    // throw 'error in api';
    return [
      {
        date: '2025-01-04',
        name: randSinger(),
      },
      {
        date: '2025-01-12',
        name: randSinger(),
      },
    ];
  }

  async importDatesFromOrfeo(): Promise<VenueDateBasic[]> {
    await new Promise((r) => setTimeout(r, 2000));
    // throw 'error in api';
    return [
      {
        date: '2025-01-08',
        name: randSinger(),
      },
      {
        date: '2025-01-18',
        name: randSinger(),
      },
    ];
  }
}

// snippets for quick debug:

// 👨‍💻 wait 1sec
// await new Promise((r) => setTimeout(r, 1000));

// 👨‍💻 dev - throw-error
// throw 'error in api';

// 👨‍💻 dev - promise-reject
// return Promise.reject();

const FAKE_VENUE_DATES: VenueDate[] = [
  {
    id: 0,
    date: '2025-10-24',
    name: 'RATM 2025',
    models: { env: '', ess: '' },
    properties: {
      presetId: FAKE_PRESETS[0].id,
      avgCapacity: FAKE_PRESETS[0].avgCapacity,
    },
    stats: {
      totalAll: 15,
      totalMen: 5,
      totalWomen: 5,
      totalOther: 5,
    },
  },
  {
    id: 1,
    date: '2025-10-22',
    name: 'Tryo',
    models: { env: '', ess: '' },
    properties: {
      presetId: FAKE_PRESETS[0].id,
      avgCapacity: FAKE_PRESETS[0].avgCapacity,
    },
    stats: {
      totalAll: 20,
      totalMen: 5,
      totalWomen: 10,
      totalOther: 5,
    },
  },
];
